<template>
  <div class="container" element-loading-background="rgba(0, 0, 0, 0.8)">
    <HeaderDateil></HeaderDateil>
    <div class="user-box">
      <div class="userinfo">
        <img src="../../../assets/exam/head.png" />
        <span class="username">{{userName}}</span>
        <div class="score-box">
          <span class="score">{{ score.toFixed(2) }}分</span>
          <span>感谢你的作答！</span>
        </div>
      </div>
      <div class="btn-box">
        <el-button @click="close">关闭页面</el-button>
        <el-button type="primary" @click="textAgain">再考一次</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import HeaderDateil from '@/components/headerDateil';

export default {
  components: {
    HeaderDateil,
  },
  data() {
    return {
      score: 0,
      userName: '',
      toRoute: '',
      fromRoute: '',
    };
  },
  created() {
    this.getScore();
  },
  watch: {
    $route(to, from) {
      this.toRoute = to.name;
      this.fromRoute = from.name;
    },
  },
  methods: {
    //再考一次
    textAgain() {
      this.$router.go(-1);

      // if(this.toRoute=='Breakthrough'){
      //   this.$router.push({
      //     path:'/Breakthrough'
      //   })
      // }else{
      //   this.$router.push({
      //     path:'/BrushTopic'
      //   })
      // }
    },
    //关闭考试
    close() {
      this.$router.push({
        path: '/exam',
      });
    },
    //获取分数
    getScore() {
      this.score = parseInt(this.$route.query.score);
      this.userName = this.$route.query.userName;
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  width: 100%;
  height: 100%;
}
.user-box {
  margin: 0 auto;
  width: 900px;
  height: 900px;
  background: #ffffff;
  display: flex;
  align-items: center;
}
.userinfo {
  width: 650px;
  height: 400px;
  box-shadow: 0px 3px 6px rgb(0 0 0 / 16%);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  > img {
    width: 80px;
    height: 80px;
    padding: 20px 0;
  }
  .username {
    font-size: 26px;
    font-weight: 600;
    text-align: center;
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .score {
    font-size: 44px;
    font-weight: 500;
    color: #1a8cfe;
    padding: 20px 0;
  }
}
.btn-box {
  margin-left: 10px;
  height: 400px;
  display: flex;
  align-items: flex-end;
  .el-button {
    height: 40px;
  }
}
.score-box {
  display: flex;
  flex-direction: column;
  justify-content: center;
}
</style>